// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ql-z","tupacHeader":"rl-z","tupacHeader2":"sl-z","tupacMenu":"tl-z","tupacMenu2":"ul-z","tupacMain":"vl-z","tupacMain2":"wl-z"};